import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Search, FileText, Users, Package, Plus } from 'lucide-react'
import {
  CommandDialog, CommandEmpty, CommandGroup, CommandInput,
  CommandItem, CommandList, CommandSeparator
} from '@/components/ui/command'
import { Button } from '@/components/ui/button'

export function GlobalSearch() {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault()
        setOpen(true)
      }
    }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [])

  const runCommand = (fn: () => void) => {
    setOpen(false)
    fn()
  }

  return (
    <>
      <Button
        variant="outline"
        className="hidden md:flex items-center gap-2 text-muted-foreground w-52 justify-between"
        onClick={() => setOpen(true)}
      >
        <div className="flex items-center gap-2">
          <Search className="h-3.5 w-3.5" />
          <span className="text-sm">Search...</span>
        </div>
        <kbd className="pointer-events-none hidden h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium opacity-100 sm:flex">
          ⌘K
        </kbd>
      </Button>

      <Button variant="ghost" size="icon" className="md:hidden" onClick={() => setOpen(true)}>
        <Search className="h-4 w-4" />
      </Button>

      <CommandDialog open={open} onOpenChange={setOpen}>
        <CommandInput placeholder="Search invoices, customers, products..." />
        <CommandList>
          <CommandEmpty>No results found.</CommandEmpty>
          <CommandGroup heading="Quick Actions">
            <CommandItem onSelect={() => runCommand(() => navigate('/invoices/new'))}>
              <Plus className="mr-2 h-4 w-4" />
              New Invoice
              <span className="ml-auto text-xs text-muted-foreground">⌘N</span>
            </CommandItem>
            <CommandItem onSelect={() => runCommand(() => navigate('/expenses?new=1'))}>
              <Plus className="mr-2 h-4 w-4" />
              New Expense
              <span className="ml-auto text-xs text-muted-foreground">⌘E</span>
            </CommandItem>
            <CommandItem onSelect={() => runCommand(() => navigate('/customers/new'))}>
              <Plus className="mr-2 h-4 w-4" />
              New Customer
            </CommandItem>
          </CommandGroup>
          <CommandSeparator />
          <CommandGroup heading="Navigate">
            <CommandItem onSelect={() => runCommand(() => navigate('/invoices'))}>
              <FileText className="mr-2 h-4 w-4" />
              Invoices
            </CommandItem>
            <CommandItem onSelect={() => runCommand(() => navigate('/customers'))}>
              <Users className="mr-2 h-4 w-4" />
              Customers
            </CommandItem>
            <CommandItem onSelect={() => runCommand(() => navigate('/products'))}>
              <Package className="mr-2 h-4 w-4" />
              Products
            </CommandItem>
          </CommandGroup>
        </CommandList>
      </CommandDialog>
    </>
  )
}
